import { TouchEvent, useRef } from 'react';

export const useLongPress = (fn: () => void, threshold = 300) => {
  const timer = useRef<number>(0);
  const onTouchStart = () => {
    timer.current = new Date().getTime();
  };

  const onTouchEnd = (e: TouchEvent) => {
    const pressTime = new Date(new Date().getTime() - timer.current).getMilliseconds();
    if (pressTime < threshold) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    fn();
  };

  return { onTouchStart, onTouchEnd };
};
